type Props = {
  /** アコーディオンが開いているかどうか。 */
  isOpen: boolean;
  /** コンポーネント内に表示される子要素。 */
  children: React.ReactNode;
};

/** アコーディオンの子要素のコンポーネント。 */
export const AccordionToggleContent = ({ isOpen, children }: Props) => (
  <div className="flex flex-col gap-[24px]">
    {isOpen ? children : <></>}
    <hr className="border-textSecondary" />
  </div>
);
